import { render } from "./IconConfig.vue?vue&type=template&id=4c4bc32c"
import script from "./IconConfig.vue?vue&type=script&lang=js"
export * from "./IconConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__